import {DtoTrumpfCompanyRequestInterface, DtoTrumpfCompanyResponseInterface, TrumpfCompanyModel} from "../interfaces";

export const mapTrumpfCompanyFromDto = (dto: DtoTrumpfCompanyResponseInterface): TrumpfCompanyModel => {
  return {
    name: dto.name,
    country: dto.country,
    isAgency: dto.isAgency,
    shortCode: dto.shortCode ?? "",
    customerOrgCount: dto.customerOrgCount ?? 0,
    changedBy: dto.changedBy,
    changedTimestamp: dto.changedTimestamp
  };
};

export const mapTrumpfCompanyFromDtoArray = (array: Array<DtoTrumpfCompanyResponseInterface>): Array<TrumpfCompanyModel> => {
  const result: Array<TrumpfCompanyModel> = [];

  array.forEach(dto => {
    result.push(mapTrumpfCompanyFromDto(dto));
  });

  return result;
};

export const mapTrumpfCompanyToDto = (model: TrumpfCompanyModel): DtoTrumpfCompanyRequestInterface => {
  return {
    name: model.name,
    country: model.country,
    isAgency: model.isAgency ?? false
  };
};
